import React,{useRef as UseRef}  from 'react'
import './contact.css';
import {MdOutlineEmail} from 'react-icons/md'
import {FiLinkedin} from 'react-icons/fi'

import {IoLogoWhatsapp} from 'react-icons/io'

import emailjs from '@emailjs/browser';


const url='https://www.linkedin.com/messaging/thread/2-MjIyMDYyOTEtMjUyMS00YTU3LTgxNTAtZWFkMWFmZWM3NGU5XzAxMw==/'

const contact=()=> {
  const form =UseRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_qipbrxa', 'template_t5se7xo', form.current, 'c-WFogH1k7ykGAfQ2')
    e.target.reset();
  };

  return (
    <section id='contact'>
      <h5>Get In Touch</h5>
      <h2>Contact Me</h2>

      <div className='container contact_container'>
        <div className='contact_options'>
           <article className='contact_option'> 
           <MdOutlineEmail className='contact_option_icon'/>
             <h4>Email</h4>
             <h5>Click below</h5>
             <a href='mailto:araj6205444@gmail.com' target="_blank">Send a message</a>
           </article>

           <article className='contact_option'> 
            <FiLinkedin className='contact_option_icon'/>
             <h4>Messeng  </h4>
             <h5>LinkedIN</h5>
             <a href={url} target="_blank">Send a message</a>
           </article>

           <article className='contact_option'> 
           <IoLogoWhatsapp className='contact_option_icon'/>
             <h4>Whatsaap</h4>
             <h5>Click below </h5>
             <a href='https://wa.me/918210880450' target="_blank">Send a message</a>
           </article>
        </div>
        {/* end of contact option */}
        <form ref={form} onSubmit={sendEmail}>
          <input type='text' name='name' placeholder='Your full Name' required/>
          <input type='email' name='email' placeholder='Enter Your Email' required/>
          <textarea name='message' row="17" placeholder="enter your message" required></textarea>
          <button type='submit' className='btn btn-primary'>send message</button>

        </form>
      </div>
    </section >
  )
}

export default contact